/**
 * Preview for a critique (comment) target
 *
 * @module pages/tasks/components/previews/CritiqueTargetPreview
 */

import type { TargetPreviewProps } from '../../types';

export function CritiqueTargetPreview({ task }: TargetPreviewProps) {
  return (
    <div className="flex items-center gap-3 p-2 bg-surface-2/50 rounded border border-border/30">
      <div className="w-12 h-12 bg-surface-2 rounded flex items-center justify-center text-muted">
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
        </svg>
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-xs text-muted">Critique</div>
        {task.description && (
          <div className="text-sm text-foreground truncate">{task.description}</div>
        )}
      </div>
    </div>
  );
}
